import { get, post } from "services/httpService";

export const STRIPE_SUCCESS_URL = import.meta.env.REACT_APP_STRIPE_SUCCESS_URL;

const SERVICE_URLS = {
  subscribeToPremiumPlan: () => `subscribe/`,
  unsubscribePlan: () => `cancel-subscription/`,
  getPlans: () => `plans/`,
  continuePremiumPlan: () => `continue-subscription/`,
  previewUpgrade: () => `subscription/preview-upgrade/`,
};

export const subscribeToPremiumPlan = (params) =>
  get(SERVICE_URLS.subscribeToPremiumPlan(), params);

export const unsubscribePlan = (reason) => {
  const payload = {
    reason,
  };
  return post(SERVICE_URLS.unsubscribePlan(), payload);
};

export const getPlans = (payload) => get(SERVICE_URLS.getPlans(), payload);

export const continuePremiumPlan = () =>
  post(SERVICE_URLS.continuePremiumPlan());

export const previewUpgrade = (planId) =>
  get(SERVICE_URLS.previewUpgrade(), { plan: planId });
